import React from 'react';
import FramiButton from './FramiButton';
import { CheckCancel, CheckCircle, ChevronDown, ChevronUp } from '../studio/styled';
import { FaPlus } from "react-icons/fa6";

const AccordionButton = ({ className, dataPh, dataCy, title, checked, isOpen, onClick, additionalClassName, showCancelIcon, onCancel }) => (
    <FramiButton
        className={className}
        dataPh={dataPh}
        dataCy={dataCy}
        onClick={onClick}
        leftIcon={!checked && <FaPlus size={16}/>}
        rightIcon={(checked && showCancelIcon) ? <CheckCancel onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCancel();
        }}/> : null}
        title={title}
        iconShowMinWidth={0}
        additionalClassName={isOpen ? 'menuOpen ' : checked ? 'selected' : additionalClassName}
    />
);

export default AccordionButton;
